// este módulo es una mezcla de:
// https://dev.to/4unkur/how-to-use-laravel-translations-in-js-vue-files-ia
// https://github.com/rmariuzzo/Lang.js/blob/master/src/lang.js

const { default: axios } = require("axios");

window._translations = [];

document.addEventListener("DOMContentLoaded", function(event) { 
    init();
});

function init(){

    axios
        .get(window._url + '/translations')
        .then((response) => {

            window._translations = response.data;

        })
        .catch((error) => {

            if(typeof error.response.data.message != 'undefined'){
                messages.error(error.response.data.message);
            } else {
                messages.error(error.response.statusText);
            }
            
        })
        .finally(() => {

            init_locale();

        });

    window.__ = trans;
    window.trans = trans;
    window.trans_choice = trans_choice;

    console.log('setting locales');

    $('.set_locale').click(function(ev){
        ev.preventDefault();

        const locale = $(this).attr('locale');
        
        setLocale(locale).then(() => {
            window.location.href = window.location.href;
        });

    });

}

const PARSLEY_LOCALE_MAP = { 'pt': 'pt-pt' };

function init_locale(){

    console.log('locale init: ' + window._locale);
    const parsleyLocale = PARSLEY_LOCALE_MAP[window._locale] || window._locale;
    window.Parsley.setLocale(parsleyLocale);

}

// https://github.com/symfony/translation/blob/460390765eb7bb9338a4a323b8a4e815a47541ba/Interval.php
var intervalRegexp = /^({\s*(\-?\d+(\.\d+)?[\s*,\s*\-?\d+(\.\d+)?]*)\s*})|([\[\]])\s*(-Inf|\*|\-?\d+(\.\d+)?)\s*,\s*(\+?Inf|\*|\-?\d+(\.\d+)?)\s*([\[\]])$/;
var anyIntervalRegexp = /({\s*(\-?\d+(\.\d+)?[\s*,\s*\-?\d+(\.\d+)?]*)\s*})|([\[\]])\s*(-Inf|\*|\-?\d+(\.\d+)?)\s*,\s*(\+?Inf|\*|\-?\d+(\.\d+)?)\s*([\[\]])/;

export function trans(key, replace, locale) {

    replace = typeof replace !== 'undefined'
    ? replace
    : {};

    locale = locale || window._locale;

    let translation, translationNotFound = true

    if(typeof window._translations == 'undefined' || typeof window._translations[locale] == 'undefined'){
        return key;
    }

    // primero se busca la cadena de traducción en los ficheros php

    try {
        
        translation = key.split('.')
                        .reduce((t, i) => t[i] || null, window._translations[locale].php);

        if(translation){
            translationNotFound = false;
        }

    } catch(e) {
        translation = key;
    }

    // si no se ha encontrado se busca en el json,
    // si no se encuentra y no estamos en el locale fallback se llama a la misma funcion con el locale de fallback
    // si estamos en el locale de fallback se devuelve la key

    try {

        if(translationNotFound){
            translation = window._translations[locale]['json'][key]
                ? window._translations[locale]['json'][key]
                : (locale != window._fallback_locale ? __(key, replace, window._fallback_locale) : key);
        }

        // sustituimos las variables

        _.forEach(replace, (value, key) => {
            translation = translation.replace(':' + key, value)
        });

    } catch(e) {
        translation = key;
    }

    return translation;

}

export function trans_choice(key, number, replace, locale) {

    replace = typeof replace !== 'undefined'
        ? replace
        : {};

    locale = locale || window._locale;

    // se inyecta la variable count en el objeto de reemplazos
    replace.count = number;

    // se recupera el message con la funcion trans y se separan las opciones
    // si solo hay una opción se devuelve directamente el message recuperado

    var message = trans(key, replace, locale);
    var messageParts = message.split('|');

    if(messageParts.length === 1){
        return message;
    }

    // obtenemos las reglas de cada opción

    var explicitRules = [];

    for(var i = 0; i < messageParts.length; i++){

        messageParts[i] = messageParts[i].trim();

        if(anyIntervalRegexp.test(messageParts[i])){
            var messageSpaceSplit = messageParts[i].split(/\s/);
            explicitRules.push(messageSpaceSplit.shift());
            messageParts[i] = messageSpaceSplit.join(' ');
        }

    }

    // Check the explicit rules
    for(var j = 0; j < explicitRules.length; j++){
        if(_testInterval(number, explicitRules[j])){
            return messageParts[j];
        }
    }

    var pluralForm = _getPluralForm(number, locale);
    return messageParts[pluralForm];

};

export function setLocale(locale){
    
    return new Promise((resolve, reject) => {

        axios
            .post(window._url + '/translations/' + locale)
            .then((response) => {

                window._locale = locale;
                init_locale();
                resolve();

            })
            .catch((error) => {

                if(typeof error.response.data.message != 'undefined'){
                    messages.error(error.response.data.message);
                } else {
                    messages.error(error.response.statusText);
                }

                reject();
                
            });

    });
    
}

function _convertNumber(str){
    
    if(str === '-Inf'){
        return -Infinity;
    } else if (str === '+Inf' || str === 'Inf' || str === '*'){
        return Infinity;
    }
    
    return parseInt(str, 10);

}

function _testInterval(count, interval) {

    /**
     * From the Symfony\Component\Translation\Interval Docs
     *
     * Tests if a given number belongs to a given math interval.
     *
     * An interval can represent a finite set of numbers:
     *
     *  {1,2,3,4}
     *
     * An interval can represent numbers between two numbers:
     *
     *  [1, +Inf]
     *  ]-1,2[
     *
     * The left delimiter can be [ (inclusive) or ] (exclusive).
     * The right delimiter can be [ (exclusive) or ] (inclusive).
     * Beside numbers, you can use -Inf and +Inf for the infinite.
     */

    if(typeof interval !== 'string') {
        throw 'Invalid interval: should be a string.';
    }

    interval = interval.trim();

    var matches = interval.match(intervalRegexp);
    if(!matches){
        throw 'Invalid interval: ' + interval;
    }

    if(matches[2]){
        
        var items = matches[2].split(',');
        for (var i = 0; i < items.length; i++) {
            if (parseInt(items[i], 10) === count) {
                return true;
            }
        }

    } else {

        // Remove falsy values.
        matches = matches.filter(function(match) {
            return !!match;
        });

        var leftDelimiter = matches[1];
        var leftNumber = _convertNumber(matches[2]);
        if(leftNumber === Infinity){
            leftNumber = -Infinity;
        }
        var rightNumber = _convertNumber(matches[3]);
        var rightDelimiter = matches[4];

        return (leftDelimiter === '[' ? count >= leftNumber : count > leftNumber)
            && (rightDelimiter === ']' ? count <= rightNumber : count < rightNumber);

    }

    return false;

}

/**
 * Returns the plural position to use for the given locale and number.
 *
 * The plural rules are derived from code of the Zend Framework (2010-09-25),
 * which is subject to the new BSD license (http://framework.zend.com/license/new-bsd).
 * Copyright (c) 2005-2010 Zend Technologies USA Inc. (http://www.zend.com)
 *
 * @param {Number} count
 * @param {String} locale
 * @return {Number}
 */
function _getPluralForm(count, locale){

    switch (locale) {
        case 'az':
        case 'bo':
        case 'dz':
        case 'id':
        case 'ja':
        case 'jv':
        case 'ka':
        case 'km':
        case 'kn':
        case 'ko':
        case 'ms':
        case 'th':
        case 'tr':
        case 'vi':
        case 'zh':
            return 0;

        case 'af':
        case 'bn':
        case 'bg':
        case 'ca':
        case 'da':
        case 'de':
        case 'el':
        case 'en':
        case 'eo':
        case 'es':
        case 'et':
        case 'eu':
        case 'fa':
        case 'fi':
        case 'fo':
        case 'fur':
        case 'fy':
        case 'gl':
        case 'gu':
        case 'ha':
        case 'he':
        case 'hu':
        case 'is':
        case 'it':
        case 'ku':
        case 'lb':
        case 'ml':
        case 'mn':
        case 'mr':
        case 'nah':
        case 'nb':
        case 'ne':
        case 'nl':
        case 'nn':
        case 'no':
        case 'om':
        case 'or':
        case 'pa':
        case 'pap':
        case 'ps':
        case 'pt':
        case 'so':
        case 'sq':
        case 'sv':
        case 'sw':
        case 'ta':
        case 'te':
        case 'tk':
        case 'ur':
        case 'zu':
            return (count == 1)
                ? 0
                : 1;

        case 'am':
        case 'bh':
        case 'fil':
        case 'fr':
        case 'gun':
        case 'hi':
        case 'hy':
        case 'ln':
        case 'mg':
        case 'nso':
        case 'xbr':
        case 'ti':
        case 'wa':
            return ((count === 0) || (count === 1))
                ? 0
                : 1;

        case 'be':
        case 'bs':
        case 'hr':
        case 'ru':
        case 'sr':
        case 'uk':
            return ((count % 10 == 1) && (count % 100 != 11))
                ? 0
                : (((count % 10 >= 2) && (count % 10 <= 4) && ((count % 100 < 10) || (count % 100 >= 20)))
                    ? 1
                    : 2);

        case 'cs':
        case 'sk':
            return (count == 1)
                ? 0
                : (((count >= 2) && (count <= 4))
                    ? 1
                    : 2);

        case 'ga':
            return (count == 1)
                ? 0
                : ((count == 2)
                    ? 1
                    : 2);

        case 'lt':
            return ((count % 10 == 1) && (count % 100 != 11))
                ? 0
                : (((count % 10 >= 2) && ((count % 100 < 10) || (count % 100 >= 20)))
                    ? 1
                    : 2);

        case 'sl':
            return (count % 100 == 1)
                ? 0
                : ((count % 100 == 2)
                    ? 1
                    : (((count % 100 == 3) || (count % 100 == 4))
                        ? 2
                        : 3));

        case 'mk':
            return (count % 10 == 1)
                ? 0
                : 1;

        case 'mt':
            return (count == 1)
                ? 0
                : (((count === 0) || ((count % 100 > 1) && (count % 100 < 11)))
                    ? 1
                    : (((count % 100 > 10) && (count % 100 < 20))
                        ? 2
                        : 3));

        case 'lv':
            return (count === 0)
                ? 0
                : (((count % 10 == 1) && (count % 100 != 11))
                    ? 1
                    : 2);

        case 'pl':
            return (count == 1)
                ? 0
                : (((count % 10 >= 2) && (count % 10 <= 4) && ((count % 100 < 12) || (count % 100 > 14)))
                    ? 1
                    : 2);

        case 'cy':
            return (count == 1)
                ? 0
                : ((count == 2)
                    ? 1
                    : (((count == 8) || (count == 11))
                        ? 2
                        : 3));

        case 'ro':
            return (count == 1)
                ? 0
                : (((count === 0) || ((count % 100 > 0) && (count % 100 < 20)))
                    ? 1
                    : 2);

        case 'ar':
            return (count === 0)
                ? 0
                : ((count == 1)
                    ? 1
                    : ((count == 2)
                        ? 2
                        : (((count % 100 >= 3) && (count % 100 <= 10))
                            ? 3
                            : (((count % 100 >= 11) && (count % 100 <= 99))
                                ? 4
                                : 5))));

        default:
            return 0;
    }

}
